import script from "./FaqsSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./FaqsSection.vue?vue&type=script&setup=true&lang=ts"

import "./FaqsSection.vue?vue&type=style&index=0&id=33d836d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33d836d5"]])

export default __exports__